import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

const CartCount = () => {
  const { cart } = useSelector((state) => state.cart)
  const countContainer = useRef(null)
  useEffect(() => {
    countContainer.current.closest('[data-cart-open]').classList.toggle('header-cart-btn__active', cart.item_count > 0)
  }, [cart])

  return (
    <span ref={countContainer}>{ cart.item_count }</span>
  )
}

export default CartCount